import { Injectable } from '@angular/core';
import { ApiEvsService } from 'app/common/services/ApiEvs.service';
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from "environments/environment";

@Injectable()
export class CustomerService {
  url2 = environment.qrcode_url_aps;
  headers: Headers;

  constructor(private http: ApiEvsService, private http2: Http) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Content-Type": "application/json",
      Authorization: `${token}`,
    });
  }

  public downloadExcelExample() {
    const type = 'application/vnd.ms-excel';
    const options = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: new Headers({ 'Accept': type })
    });
    return this.http.getFile(`/g_customers/excel/import/template`, options);
  }
  public downloadExcelAgency() {
    const type = 'application/vnd.ms-excel';
    const options = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: new Headers({ 'Accept': type })
    });
    return this.http.getFile(`/qr_aps/agencies/export`, options);
  }
  uploadFileCustomer(file?: any, type?: any): Observable<any> {
    this.headers.delete("Content-Type");
    if (localStorage.getItem("Access-Token")) {
      this.headers.set("authorization", localStorage.getItem("Access-Token"));
    }
    const lang = localStorage.getItem('lang') || 'vi';
    this.headers.set('Accept-Language', lang);
    let formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("type", type)
    return this.http2
      .post(`${this.url2}/g_customer/import`, formData, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }
  uploadFileCustomerConfirm(file?: any): Observable<any> {
    this.headers.delete("Content-Type");
    if (localStorage.getItem("Access-Token")) {
      this.headers.set("authorization", localStorage.getItem("Access-Token"));
    }
    let formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("type", "2")
    console.log("formData", formData);

    return this.http2
      .post(`${this.url2}/g_customer/import`, formData, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

  public ListCustomer(request) {
    return this.http.get('/g_customers', request);
  }

  public downloadExcel(request: any) {
    return this.http.getExcel('/g_customers/excel', request);
  }

  public ListCustomerByPhone(phone, request) {
    return this.http.get('/g_customers/' + phone + '/list', request);
  }

  public updateById(id, data) {
    return this.http.put('/g_customers/' + id, data);
  }

  public deleteById(id) {
    return this.http.get('/g_customers/delete?id=' + id);
  }

  public getDetailById(id) {
    return this.http.get('/g_customers/' + id);
  }

  public getUserByPhone(phone: any) {
    return this.http.get('/g_customer-phone/' + phone);
  }

  /** [27-10-2022]-Tuanba :Export Danh sách khách hàng gồm các trường động **/

  public getListVerifyCustomer(customer_id: any, params) {
    return this.http.get(`/qr-core-aps/customers/verify?customer_id=${customer_id}`, params)
  }

  public exportVerifyCustomer(history_care: any, stamp_verify: any, fields: any, params: any) {
    return this.http.get(`/qr-core-aps/customer/export?history_care=${history_care}&stamp_verify=${stamp_verify}&fields=${fields}`, params)
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/customer/customer.service.ts